// Import basic libraries used throughout all applications
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';

// Import plugins from the eflib
import auth from '@lib/plugins/auth';
import '@lib/plugins/axios';
import Moment from '@lib/plugins/moment';

// Load Font Awesome icons
import '@lib/../assets/fontawesome-pro-7.3.0-web/css/all.min.css';
import '@lib/../assets/fontawesome-pro-7.3.0-web/css/solid.min.css';
import '@lib/../assets/fontawesome-pro-7.3.0-web/css/brands.min.css';

// Bootstrap the main application layout from the eflib
import '@lib/plugins/bootstrap';
import App from '@lib/layouts/Base.vue';

// Import application specific code
import router from '@/router';

// Localization: the user's pick, else the browser language
import I18n from '@lib/plugins/i18n';
import { merge } from 'lodash-es';

import lib_locale from '@lib/locale';
import app_locales from '@/locale/index';
import unifi_integration_locale from '../../modules/unifi-integration/resources/js/locale';

// Create main vue app
const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(auth);
app.use(I18n, window.env.app?.env == 'e2e' ? {} : merge(lib_locale, unifi_integration_locale, app_locales));
app.use(PrimeVue);
app.use(Moment);

import EfLib from '@lib/eflib';
app.use(EfLib, {
	contributions: {
		slots: {
			// The app's own tab on the lib's admin settings page
			'admin.settings': [
				{
					id: 'network_lists',
					icon: 'fa-network-wired',
					group: 'integrations',
					component: () => import('@/pages/admin/settings/NetworkLists.vue'),
				},
			],
		},
	},
});

// Load WebSocket broadcast plugin
import AppBroadcastPlugin from '@lib/plugins/broadcast';
app.use(AppBroadcastPlugin);

// Add a sidebar
import Sidebar from '@/sidebar';
app.use(Sidebar);

// The context works pretty much the same in all apps and is only customized in the app
import { AppApplicationPlugin } from '@lib/plugins/layouts/application';
app.use(AppApplicationPlugin);

import Filters from '@lib/filters';
app.use(Filters);

// Enable performance tracking
if (import.meta.env.DEV) {
	app.config.performance = true;
}

// Mount the app
app.mount('#app');
